<script setup lang="ts">
interface Props {
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
})

const sizeClasses = {
  sm: 'tw-w-6 tw-h-6',
  md: 'tw-w-8 tw-h-8',
  lg: 'tw-w-10 tw-h-10',
  xl: 'tw-w-16 tw-h-16',
}
</script>

<template>
  <div :class="sizeClasses[props.size]">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="tw-w-full tw-h-full">
      <defs>
        <linearGradient id="logoGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color: #3b82f6" />
          <stop offset="100%" style="stop-color: #1d4ed8" />
        </linearGradient>
        <linearGradient id="logoGrad2" x1="100%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style="stop-color: #1d4ed8" />
          <stop offset="100%" style="stop-color: #3b82f6" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="9" fill="url(#logoGrad1)" opacity="0.9" />
      <circle cx="20" cy="12" r="9" fill="url(#logoGrad2)" opacity="0.7" />
      <circle cx="16" cy="20" r="9" fill="url(#logoGrad1)" opacity="0.8" />
      <circle cx="16" cy="14" r="3" fill="white" opacity="0.9" />
    </svg>
  </div>
</template>
